import { GeneralModel } from "./general.model";

export class Country extends GeneralModel {
}


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_core_angular/src/app/models/country.model.ts